<script setup>
import {Carousel, Navigation, Pagination, Slide} from 'vue3-carousel';
import { computed } from 'vue';
import { getImgErrorUrl, getPlaceholderUrl, getS3Url } from '@/helpers/utils';

const carouselConfig = {
  itemsToShow: 1,
  wrapAround: true,
  autoplay: 6000,
  pauseAutoplayOnHover: true,
}

const props = defineProps({
  imageList: { type: Array, default: []}
})
const hasManyPhotos = computed(() => props.imageList.length > 1)

const imagesWithUrls = computed(() => {
  if (props.imageList.length === 0) {
    const placeholder = getPlaceholderUrl();
    return [placeholder];
  }
  const imgList = [];
  props.imageList.forEach(imageName => {
    const s3Url = getS3Url(imageName);
    imgList.push(s3Url);
  })
  return imgList;
})

function showErrorImage(event) {
  event.target.src = getImgErrorUrl();
}
</script>

<template>
  <Carousel v-bind="carouselConfig">
    <Slide v-for="imgUrl in imagesWithUrls" :key="imgUrl">
      <div class="carousel__item">
        <img class="carousel-img" :src="imgUrl" @error="showErrorImage" alt="image">
      </div>
    </Slide>
    <template #addons>
      <Navigation v-if="hasManyPhotos"/>
      <Pagination v-if="hasManyPhotos"/>
    </template>
  </Carousel>
</template>

<style scoped>
.carousel-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.carousel__item {
  width: 100%;
  overflow: hidden;
}
</style>